export const name = {
    'en': 'ThingSpeak',
    'zh-tw': 'ThingSpeak'
};

export const fetchThingSpeak = {
    'en': 'ThingSpeak [id] send event [event] value1 [value1] value2 [value2] value3 [value3] value4 [value4] value5 [value5] value6 [value6] value7 [value7] value8 [value8]',
    'zh-tw': 'ThingSpeak [id] 傳送事件 [event] 參數1 [value1] 參數2 [value2] 參數3 [value3] 參數4 [value4] 參數5 [value5] 參數6 [value6] 參數7 [value7] 參數8 [value8]'
};
